// extracted by mini-css-extract-plugin
export default {"label":"label_label__1W-Ax","label__optional":"label_label__optional__qAERS"};